export const FORM_STYLES = {
  section: {
    card: {
      backgroundColor: 'white',
      borderRadius: { xs: '12px', md: '16px' },
      padding: { xs: '16px', sm: '20px', md: '24px' },
      boxShadow: '0 2px 12px rgba(0, 0, 0, 0.06)',
      border: '1px solid #f0f0f0',
      mb: { xs: 2, md: 3 }
    },
    header: {
      display: 'flex',
      alignItems: 'center',
      mb: { xs: 2, md: 3 },
      flexDirection: { xs: 'column', md: 'row' },
      textAlign: { xs: 'center', md: 'left' }
    },
    icon: {
      width: { xs: '40px', md: '48px' },
      height: { xs: '40px', md: '48px' },
      borderRadius: { xs: '10px', md: '12px' },
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      mr: { xs: 0, md: 2 },
      mb: { xs: 1, md: 0 }
    },
    title: {
      fontSize: { xs: '18px', sm: '20px', md: '24px' },
      fontWeight: 700,
      color: '#2C2C2C',
      fontFamily: "'Poppins', sans-serif"
    },
    subtitle: {
      fontSize: { xs: '14px', md: '16px' },
      fontWeight: 600,
      color: '#6C6C6C',
      mb: 2,
      fontFamily: "'Poppins', sans-serif"
    }
  },
  layout: {
    twoColumn: {
      display: 'flex',
      gap: { xs: '16px', md: '24px' },
      flexDirection: { xs: 'column', md: 'row' }
    },
    container: {
      maxWidth: 700,
      mx: 'auto',
      px: { xs: 2, sm: 3, md: 0 }
    }
  },
  input: {
    base: {
      width: '100%',
      '& .MuiOutlinedInput-root': {
        backgroundColor: '#F9FCFF',
        border: '2px solid #E8E8E8',
        borderRadius: { xs: '10px', md: '12px' },
        fontSize: { xs: '15px', md: '16px' },
        fontWeight: 500,
        fontFamily: "'Poppins', sans-serif",
        '& .MuiOutlinedInput-notchedOutline': {
          border: 'none'
        },
        '& input': {
          padding: { xs: '10px 14px', md: '12px 16px' },
          color: '#2C2C2C'
        }
      }
    },
    dropdown: {
      '& .MuiSelect-select': {
        backgroundColor: '#F9FCFF',
        border: '2px solid #E8E8E8',
        borderRadius: { xs: '10px', md: '12px' },
        padding: { xs: '10px 14px', md: '12px 16px' },
        fontSize: { xs: '15px', md: '16px' },
        fontWeight: 500,
        fontFamily: "'Poppins', sans-serif",
        minHeight: '20px',
        display: 'flex',
        alignItems: 'center'
      },
      '& .MuiOutlinedInput-notchedOutline': {
        border: 'none'
      },
      '& .MuiSelect-icon': {
        right: { xs: '10px', md: '12px' },
        fontSize: { xs: '20px', md: '24px' },
        color: '#6C6C6C'
      }
    }
  },
  label: {
    fontSize: { xs: '14px', md: '16px' },
    fontWeight: 600,
    color: '#6C6C6C',
    mb: 1.5,
    fontFamily: "'Poppins', sans-serif"
  },
  optionCard: {
    backgroundColor: 'white',
    borderRadius: 2,
    p: 2,
    textAlign: 'center',
    border: '1px solid #f1f5f9',
    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
    height: '100%'
  },
  optionButton: {
    flex: 1,
    py: 1,
    px: 1.5,
    borderRadius: 4,
    cursor: 'pointer',
    fontWeight: 600,
    transition: 'all 0.2s'
  }
};

export const ICON_COLORS = {
  housing: '#62B8E9',
  calendar: '#62B8E9',
  home: '#62B8E9',
  euro: '#62B8E9',
  lightbulb: '#62B8E9',
  creditCard: '#62B8E9',
  heating: '#62B8E9',
  water: '#62B8E9',
  electricity: '#62B8E9',
  internet: '#62B8E9',
  parking: '#62B8E9',
  furniture: '#62B8E9'
}; 